import React, { useState, useEffect } from "react";
import Swiper from "../Components/Swiper";
import Sweetalert from "sweetalert2";
import axios from "../Config/axios";
import customAxios from "axios";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import {
  groupBy,
  keys,
  orderBy,
  replace,
  size,
  slice,
  toInteger,
  toLength,
  toNumber,
  toString,
} from "lodash";
import DownloadLinkBase64 from "../Components/DownloadLinkBase64";
import { URLS } from "../Constants/constants";

function Check() {
  const [acntCode, setAcntCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFile, setIsLoadingFile] = useState(false);
  const [count, setCount] = useState(0);
  const [responseHeaderData, setResponseHeaderData] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [visibleItems, setVisibleItems] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [emailData, setEmailData] = useState("");

  const [acntno, setAcntno] = useState("");
  const [iban, setIban] = useState("MN000000");

  function bcmod(dividend, divisor) {
    const bigDividend = window.BigInt(dividend);
    const bigDivisor = window.BigInt(divisor);
    return (bigDividend % bigDivisor).toString();
  }
  useEffect(() => {
    generateIBAN(acntno);
  }, [acntno]);

  const generateIBAN = (accountNumber) => {
    if (!accountNumber.trim()) {
      setIban("MN000000");
      return;
    }

    let controlCode = "00";
    let nationalId = "MN";
    let bankNumber = "0021";

    let sanitizedAcntno = accountNumber.replace(/\s/g, "");
    let acntno2Padded = sanitizedAcntno.padStart(12, "0");

    let checkValue = bankNumber + acntno2Padded + "22" + "23" + controlCode;
    let examValue = bcmod(checkValue, "97");

    let lastValue = 98 - examValue;
    let lastValueAdded = "";
    if (toString(lastValue).length < 2) {
      lastValueAdded = toString(lastValue).padStart(2, "0");
    } else {
      lastValueAdded = lastValue;
    }
    let ibanValue = nationalId + lastValueAdded + bankNumber + acntno2Padded;
    setIban(ibanValue);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.outerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const submit = () => {
    if (size(iban) > 9) {
      setIsLoading(true);
      axios
        .post("check/lottery", { acnt_code: iban })
        .then(async (res) => {
          let { code, message, data } = res.data;
          let orderedDt = orderBy(data, ["sublotteryid"], ["asc"]);
          let groupedData = groupBy(orderedDt, (item) => item?.sublotteryid);
          let onlyHeaders = keys(groupedData);
          let orderedHeaders = orderBy(onlyHeaders, (n) => parseInt(n), "desc");

          if (code === 200) {
            getEmailData();
            setCount(data[0]["row_count"]);
            setResponseHeaderData(orderedHeaders);
            setResponseData(groupedData);
          } else if (code === 400) {
            setCount(res?.data?.data?.exists);
            Sweetalert.fire({
              title: message,
              icon: "error",
              confirmButtonText: "Хаах",
            });
            clearData();
          } else if (code === 500) {
            Sweetalert.fire({
              title: "Мэдээлэл олдсонгүй",
              icon: "error",
              confirmButtonText: "Хаах",
            });
            clearData();
          } else {
            Sweetalert.fire({
              title: message,
              icon: "error",
              confirmButtonText: "Хаах",
            });
            clearData();
          }
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
          clearData();
        });
    } else {
      Sweetalert.fire({
        title: "Дансны дугаар оруулна уу",
        icon: "warning",
        confirmButtonText: "Хаах",
      });
    }
  };

  const getEmailData = async () => {
    setIsLoadingFile(true);
    try {
      await customAxios
        .post(
          URLS?.emailUrl,
          {
            acntCode: acntno,
            isSendEmail: false,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YXJpZzpwYXNzMTIzNDU2",
            },
          }
        )
        .then((res) => {
          let { status, message, data } = res.data;
          if (status === 200) {
            setEmailData(res?.data);
          }
        });
    } catch {
      return null;
    } finally {
      setIsLoadingFile(false);
    }
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        submit();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [acntCode, submit]);

  const clearData = () => {
    setIsLoading(false);
    setIsMobile(false);
    setResponseData([]);
    setResponseHeaderData([]);
    setCount(0);
  };

  const handleLoadMore = (header) => {
    setVisibleItems((prev) => ({
      ...prev,
      [header]: (prev[header] || 0) + 20,
    }));
  };

  return (
    <div className={`background ${isMobile ? "header-placement" : ""}`}>
      {!isMobile && <Swiper />}
      <Navbar activeLink="" />
      <div className="wrapper">
        <div className="home-title">Урамшууллын эрх шалгах</div>
        <Form className={"mb-40"}>
          {/* <FormGroup>
            <Label>Дансны дугаар оруулах</Label>
            <div className={"d-flex"}>
              <Input
                name="acntCode"
                onChange={(e) => setAcntCode(e.target.value)}
              />
            </div>
          </FormGroup> */}

          <FormGroup className="d-flex flex-column align-items-center justify-content-center">
            <div className="d-flex align-items-center position-relative">
              <span className="me-2 text-secondary">
                {slice(iban, 0, 10).join("")}
              </span>
              <input
                type="number"
                placeholder="Дансны дугаар"
                className="form-control"
                value={acntno}
                onChange={(e) => setAcntno(e.target.value)}
              />
            </div>
          </FormGroup>

          <Button
            color="primary"
            style={{ width: "100%" }}
            disabled={isLoading}
            onClick={submit}
          >
            {isLoading && (
              <div
                className="spinner-border"
                style={{ height: "18px", width: "18px" }}
                role="status"
              >
                <span className="sr-only"></span>
              </div>
            )}
            Шалгах
          </Button>
        </Form>
        {count !== 0 && (
          <div className="my-4 row align-items-center justify-content-center container ">
            <div className="col-auto">
              <h5
                className="text-center"
                style={{ color: "rgba(110,67,222,1)" }}
              >
                {"Танд нийт " + count + " урамшууллын эрх байна"}.
              </h5>
            </div>
            {isLoadingFile && (
              <span
                className="spinner-border"
                style={{ color: "rgba(110,67,222,1)" }}
                role="status"
              />
            )}
            {!isLoadingFile && emailData && (
              <DownloadLinkBase64
                filename={emailData?.fileName}
                b64string={emailData?.file}
                acntCode={acntno}
              />
            )}
          </div>
        )}
        <div className="container mt-5">
          {responseHeaderData?.map((header) => (
            <React.Fragment key={header}>
              <p className="fs-2 d-flex justify-content-between align-items-center">
                {replace(header, 0, "")}-{"р үеийн урамшууллын эрх"}:{" "}
                <span className="fs-6 ml-auto text-secondary text-center">
                  {"нийт"} {responseData[header]?.length}
                </span>
              </p>
              <div className="row justify-content-start align-items-center">
                {responseData[header]
                  ?.slice(0, visibleItems[header] || 11)
                  .map((item, index) => (
                    <div className="col-md-2 mb-4" key={index}>
                      <div className="card shadow-sm">
                        <div className="card-body text-center">
                          <h6 className="card-text mb-0">
                            {item?.lotterycode}
                          </h6>
                          <span
                            className="card-text text-muted"
                            style={{ fontSize: "10px" }}
                          >
                            {item?.createddate}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                {responseData[header]?.length >
                  (visibleItems[header] || 11) && (
                  <button
                    className="btn ml-auto col-md-2"
                    onClick={() => handleLoadMore(header)}
                  >
                    <span className="text-muted fs-2">...</span>
                  </button>
                )}
              </div>
            </React.Fragment>
          ))}
        </div>
        <Footer isMobile={isMobile} />
      </div>
    </div>
  );
}

export default Check;
